// import React, { useState } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';

// const LumpsumCalculator = () => {
//   const [investment, setInvestment] = useState(100000);
//   const [expectedReturn, setExpectedReturn] = useState(12);
//   const [timePeriod, setTimePeriod] = useState(10);
//   const [showForm, setShowForm] = useState(false);
//   const [result, setResult] = useState(null);
//   const [chartData, setChartData] = useState([]);

//   const calculate = () => {
//     const rate = expectedReturn / 100;
//     const futureValue = investment * Math.pow(1 + rate, timePeriod);
//     const estimatedReturns = futureValue - investment;
    
//     // Generate chart data
//     const data = [];
//     for (let year = 1; year <= timePeriod; year++) {
//       const value = investment * Math.pow(1 + rate, year);
//       data.push({
//         year: year,
//         investment: investment,
//         value: value
//       });
//     }
    
//     setResult({ futureValue, totalInvestment: investment, estimatedReturns });
//     setChartData(data);
//   };

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById('lumpsum-result-content');
//     html2pdf().set({ margin: 0.5, filename: `Lumpsum_Report_${userData.name}.pdf` }).from(element).save();
//     setShowForm(false);
    
//     const whatsappMessage = `Dear ${userData.name},\n\nLumpsum Investment Summary:\n• Investment: ₹${investment.toLocaleString()}\n• Period: ${timePeriod} years\n• Returns: ${expectedReturn}% p.a.\n• Future Value: ₹${result.futureValue.toLocaleString()}\n\n- Wisdom Consultancy`;
//     window.open(`https://wa.me/${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
//   };

//   return (
//     <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-xl shadow-lg p-6">
//       <h3 className="text-2xl font-bold text-primary mb-2">Lumpsum Calculator</h3>
//       <p className="text-gray-600 mb-6">Calculate the future value of your one-time investment</p>
      
//       <div className="grid md:grid-cols-2 gap-8">
//         <div className="space-y-5">
//           <div>
//             <label className="block text-gray-700 font-semibold mb-2">Investment Amount (₹)</label>
//             <input type="number" className="input-field" value={investment} onChange={(e) => setInvestment(Number(e.target.value))} />
//           </div>
//           <div>
//             <label className="block text-gray-700 font-semibold mb-2">Expected Return (% p.a.)</label>
//             <input type="number" step="0.5" className="input-field" value={expectedReturn} onChange={(e) => setExpectedReturn(Number(e.target.value))} />
//           </div>
//           <div>
//             <label className="block text-gray-700 font-semibold mb-2">Time Period (Years)</label>
//             <input type="number" className="input-field" value={timePeriod} onChange={(e) => setTimePeriod(Number(e.target.value))} />
//           </div>
//           <button onClick={calculate} className="w-full btn-primary py-3">Calculate Now</button>
//         </div>

//         {result && (
//           <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5">
//             <h4 className="font-bold text-lg text-primary mb-4">Investment Summary</h4>
//             <div className="space-y-3">
//               <div className="flex justify-between"><span>Total Investment:</span><span className="font-semibold">₹{result.totalInvestment.toLocaleString()}</span></div>
//               <div className="flex justify-between"><span>Estimated Returns:</span><span className="font-semibold text-green-600">+ ₹{result.estimatedReturns.toLocaleString()}</span></div>
//               <div className="flex justify-between pt-2 border-t"><span className="font-bold">Future Value:</span><span className="font-bold text-primary text-xl">₹{result.futureValue.toLocaleString()}</span></div>
//             </div>
//           </div>
//         )}
//       </div>

//       {chartData.length > 0 && (
//         <div className="mt-8 h-80">
//           <ResponsiveContainer width="100%" height="100%">
//             <LineChart data={chartData}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="year" label={{ value: 'Years', position: 'bottom' }} />
//               <YAxis label={{ value: 'Amount (₹)', angle: -90, position: 'left' }} />
//               <Tooltip formatter={(value) => `₹${value.toLocaleString()}`} />
//               <Legend />
//               <Line type="monotone" dataKey="investment" stroke="#8884d8" name="Investment" />
//               <Line type="monotone" dataKey="value" stroke="#82ca9d" name="Future Value" />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>
//       )}

//       <div id="lumpsum-result-content" style={{ display: 'none' }}>
//         <div style={{ padding: '20px' }}>
//           <h2 style={{ color: '#1e3c72' }}>Wisdom Consultancy - Lumpsum Investment Report</h2>
//           <table><tbody>
//             <tr><td>Investment:</td><td>₹{investment.toLocaleString()}</td></tr>
//             <tr><td>Period:</td><td>{timePeriod} years</td></tr>
//             <tr><td>Returns:</td><td>{expectedReturn}%</td></tr>
//             <tr><td>Future Value:</td><td>₹{result?.futureValue.toLocaleString()}</td></tr>
//           </tbody></table>
//         </div>
//       </div>

//       {result && (
//         <button onClick={() => setShowForm(true)} className="w-full mt-6 bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700">
//           📄 Download Report & Share on WhatsApp
//         </button>
//       )}
//       {showForm && <CalculatorForm onSubmit={handleFormSubmit} onClose={() => setShowForm(false)} calculatorType="Lumpsum" />}
//     </motion.div>
//   );
// };

// export default LumpsumCalculator;

// import React, { useState } from 'react';
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from 'recharts';

// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';

// import {
//   FaChartLine,
//   FaFilePdf,
//   FaWhatsapp,
//   FaShieldAlt,
// } from 'react-icons/fa';

// const LumpsumCalculator = () => {
//   const [investment, setInvestment] =
//     useState(100000);

//   const [expectedReturn, setExpectedReturn] =
//     useState(12);

//   const [inflationRate, setInflationRate] =
//     useState(6);

//   const [timePeriod, setTimePeriod] =
//     useState(10);

//   const [showForm, setShowForm] =
//     useState(false);

//   const [result, setResult] = useState(null);

//   const [chartData, setChartData] = useState([]);

//   const calculate = () => {
//     const rate = expectedReturn / 100;

//     const inflation = inflationRate / 100;

//     const futureValue =
//       investment *
//       Math.pow(1 + rate, timePeriod);

//     const inflationAdjustedValue =
//       futureValue /
//       Math.pow(
//         1 + inflation,
//         timePeriod
//       );

//     const estimatedReturns =
//       futureValue - investment;

//     const realReturns =
//       inflationAdjustedValue -
//       investment;

//     // CHART DATA
//     const data = [];

//     for (
//       let year = 1;
//       year <= timePeriod;
//       year++
//     ) {
//       const value =
//         investment *
//         Math.pow(1 + rate, year);

//       const adjusted =
//         value /
//         Math.pow(
//           1 + inflation,
//           year
//         );

//       data.push({
//         year,
//         investment,
//         value: Math.round(value),
//         adjusted: Math.round(adjusted),
//       });
//     }

//     setResult({
//       futureValue,
//       inflationAdjustedValue,
//       totalInvestment: investment,
//       estimatedReturns,
//       realReturns,
//     });

//     setChartData(data);
//   };

//   const downloadPDF = () => {
//     setShowForm(true);
//   };

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById(
//       'lumpsum-result-content'
//     );

//     const opt = {
//       margin: [0.4, 0.4, 0.4, 0.4],

//       filename: `Lumpsum_Report_${userData.name}.pdf`,

//       image: {
//         type: 'jpeg',
//         quality: 1,
//       },

//       html2canvas: {
//         scale: 2,
//       },

//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'portrait',
//       },
//     };

//     html2pdf()
//       .set(opt)
//       .from(element)
//       .save();

//     setShowForm(false);

//     // WHATSAPP MESSAGE
//     const whatsappMessage = `
// Dear ${userData.name},

// Thank you for using Wisdom Consultancy Lumpsum Calculator.

// 📊 Investment Summary

// • Investment Amount: ₹${investment.toLocaleString()}
// • Expected Return: ${expectedReturn}% p.a.
// • Inflation Rate: ${inflationRate}% p.a.
// • Investment Period: ${timePeriod} Years

// 💰 Total Investment:
// ₹${investment.toLocaleString()}

// 📈 Estimated Returns:
// ₹${Math.round(
//       result.estimatedReturns
//     ).toLocaleString()}

// 🏆 Future Value:
// ₹${Math.round(
//       result.futureValue
//     ).toLocaleString()}

// 📉 Inflation Adjusted Value:
// ₹${Math.round(
//       result.inflationAdjustedValue
//     ).toLocaleString()}

// 💹 Real Wealth Gain:
// ₹${Math.round(
//       result.realReturns
//     ).toLocaleString()}

// For personalized financial guidance contact:

// 📞 +91 9726344477
// 📧 wisdom2secure@gmail.com

// Wisdom Consultancy
// Your Trusted Partner for Wealth & Financial Security
// `;

//     window.open(
//       `https://wa.me/${
//         userData.phone
//       }?text=${encodeURIComponent(
//         whatsappMessage
//       )}`,
//       '_blank'
//     );
//   };

//   return (
//     <motion.div
//       initial={{
//         opacity: 0,
//         y: 20,
//       }}
//       animate={{
//         opacity: 1,
//         y: 0,
//       }}
//       className="bg-white rounded-[35px] shadow-xl p-6 md:p-10 border border-[#edf3ff]"
//     >
//       {/* HEADER */}
//       <div className="mb-8">
//         <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
//           <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//             <FaChartLine />
//           </div>

//           <span className="font-semibold text-[#0b1c39]">
//             Smart Wealth Planning
//           </span>
//         </div>

//         <h3 className="text-3xl md:text-4xl font-bold text-[#0b1c39] mb-3">
//           Lumpsum Calculator
//         </h3>

//         <p className="text-gray-600 text-lg leading-8">
//           Calculate your one-time
//           investment growth with
//           inflation-adjusted future
//           value projections.
//         </p>
//       </div>

//       <div className="grid lg:grid-cols-2 gap-10">
//         {/* LEFT SECTION */}
//         <div className="space-y-8">
//           {/* INVESTMENT */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Investment Amount (₹)
//             </label>

//             <input
//               type="range"
//               min="10000"
//               max="10000000"
//               step="10000"
//               value={investment}
//               onChange={(e) =>
//                 setInvestment(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 ₹10K
//               </span>

//               <span className="text-[#2e56b8] font-bold text-xl">
//                 ₹
//                 {investment.toLocaleString()}
//               </span>

//               <span className="text-gray-500 text-sm">
//                 ₹1Cr
//               </span>
//             </div>
//           </div>

//           {/* RETURN */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Expected Return (% p.a.)
//             </label>

//             <input
//               type="range"
//               min="1"
//               max="30"
//               step="0.5"
//               value={expectedReturn}
//               onChange={(e) =>
//                 setExpectedReturn(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 1%
//               </span>

//               <span className="text-[#2e56b8] font-bold text-xl">
//                 {expectedReturn}%
//               </span>

//               <span className="text-gray-500 text-sm">
//                 30%
//               </span>
//             </div>
//           </div>

//           {/* INFLATION */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Inflation Rate (% Optional)
//             </label>

//             <input
//               type="range"
//               min="0"
//               max="10"
//               step="0.5"
//               value={inflationRate}
//               onChange={(e) =>
//                 setInflationRate(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 0%
//               </span>

//               <span className="text-[#69bf74] font-bold text-xl">
//                 {inflationRate}%
//               </span>

//               <span className="text-gray-500 text-sm">
//                 10%
//               </span>
//             </div>
//           </div>

//           {/* TIME */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Time Period (Years)
//             </label>

//             <input
//               type="range"
//               min="1"
//               max="40"
//               value={timePeriod}
//               onChange={(e) =>
//                 setTimePeriod(
//                   Number(
//                     e.target.value
//                   )
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 1 Year
//               </span>

//               <span className="text-[#2e56b8] font-bold text-xl">
//                 {timePeriod} Years
//               </span>

//               <span className="text-gray-500 text-sm">
//                 40 Years
//               </span>
//             </div>
//           </div>

//           {/* BUTTON */}
//           <button
//             onClick={calculate}
//             className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg"
//           >
//             Calculate Investment
//           </button>
//         </div>

//         {/* RIGHT RESULT */}
//         {result && (
//           <motion.div
//             initial={{
//               opacity: 0,
//             }}
//             animate={{
//               opacity: 1,
//             }}
//             className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] rounded-[35px] p-8 border border-[#dce7ff]"
//           >
//             <h4 className="text-3xl font-bold text-[#0b1c39] mb-8">
//               Investment Summary
//             </h4>

//             <div className="space-y-5">
//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Total Investment
//                 </span>

//                 <span className="text-[#0b1c39] font-bold text-xl">
//                   ₹
//                   {Math.round(
//                     result.totalInvestment
//                   ).toLocaleString()}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Estimated Returns
//                 </span>

//                 <span className="text-[#69bf74] font-bold text-xl">
//                   + ₹
//                   {Math.round(
//                     result.estimatedReturns
//                   ).toLocaleString()}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Inflation Adjusted Value
//                 </span>

//                 <span className="text-[#2e56b8] font-bold text-xl">
//                   ₹
//                   {Math.round(
//                     result.inflationAdjustedValue
//                   ).toLocaleString()}
//                 </span>
//               </div>

//               <div className="bg-[#2e56b8] rounded-3xl p-6 text-white mt-5 shadow-xl">
//                 <p className="text-white/80 mb-2">
//                   Total Future Value
//                 </p>

//                 <h2 className="text-4xl font-extrabold">
//                   ₹
//                   {Math.round(
//                     result.futureValue
//                   ).toLocaleString()}
//                 </h2>
//               </div>

//               <div className="bg-white rounded-2xl p-5 shadow-sm">
//                 <p className="text-gray-500 mb-2">
//                   Real Wealth Gain After
//                   Inflation
//                 </p>

//                 <h3 className="text-3xl font-bold text-[#69bf74]">
//                   ₹
//                   {Math.round(
//                     result.realReturns
//                   ).toLocaleString()}
//                 </h3>
//               </div>
//             </div>

//             {/* DOWNLOAD */}
//             <button
//               onClick={downloadPDF}
//               className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
//             >
//               <FaFilePdf />
//               Download Professional PDF
//               Report
//             </button>
//           </motion.div>
//         )}
//       </div>

//       {/* CHART */}
//       {chartData.length > 0 && (
//         <motion.div
//           initial={{
//             opacity: 0,
//           }}
//           animate={{
//             opacity: 1,
//           }}
//           className="mt-14"
//         >
//           <h4 className="text-3xl font-bold text-[#0b1c39] mb-8">
//             Investment Growth Projection
//           </h4>

//           <div className="bg-[#f8fbff] rounded-[35px] p-6 border border-[#edf3ff]">
//             <div className="h-[420px]">
//               <ResponsiveContainer
//                 width="100%"
//                 height="100%"
//               >
//                 <LineChart data={chartData}>
//                   <CartesianGrid strokeDasharray="3 3" />

//                   <XAxis dataKey="year" />

//                   <YAxis />

//                   <Tooltip
//                     formatter={(value) =>
//                       `₹${value.toLocaleString()}`
//                     }
//                   />

//                   <Legend />

//                   <Line
//                     type="monotone"
//                     dataKey="investment"
//                     stroke="#2e56b8"
//                     strokeWidth={3}
//                     name="Investment"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="value"
//                     stroke="#69bf74"
//                     strokeWidth={3}
//                     name="Future Value"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="adjusted"
//                     stroke="#ff9800"
//                     strokeWidth={3}
//                     name="Inflation Adjusted"
//                   />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </motion.div>
//       )}

//       {/* PDF CONTENT */}
//       {result && (
//         <div
//           id="lumpsum-result-content"
//           style={{
//             display: 'none',
//           }}
//         >
//           <div
//             style={{
//               padding: '30px',
//               fontFamily: 'Arial',
//               color: '#222',
//             }}
//           >
//             {/* HEADER */}
//             <div
//               style={{
//                 borderBottom:
//                   '3px solid #2e56b8',
//                 paddingBottom: '20px',
//                 marginBottom: '20px',
//               }}
//             >
//               <h1
//                 style={{
//                   color: '#2e56b8',
//                   marginBottom: '10px',
//                 }}
//               >
//                 Wisdom Consultancy
//               </h1>

//               <p>
//                 E-44, Vasant Vihar
//                 Society,
//                 GIDC-Vadsar Road,
//                 Vadodara-390010
//               </p>

//               <p>
//                 Phone: +91
//                 9726344477 | Email:
//                 wisdom2secure@gmail.com
//               </p>

//               <p>
//                 ARN No: ARN-XXXXX
//               </p>
//             </div>

//             {/* REPORT TITLE */}
//             <h2
//               style={{
//                 textAlign: 'center',
//                 color: '#0b1c39',
//                 marginBottom: '20px',
//               }}
//             >
//               Lumpsum Investment Report
//             </h2>

//             {/* TABLE */}
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse:
//                   'collapse',
//               }}
//             >
//               <tbody>
//                 {[
//                   [
//                     'Investment Amount',
//                     `₹${investment.toLocaleString()}`,
//                   ],

//                   [
//                     'Expected Return',
//                     `${expectedReturn}%`,
//                   ],

//                   [
//                     'Inflation Rate',
//                     `${inflationRate}%`,
//                   ],

//                   [
//                     'Investment Period',
//                     `${timePeriod} Years`,
//                   ],

//                   [
//                     'Total Investment',
//                     `₹${investment.toLocaleString()}`,
//                   ],

//                   [
//                     'Estimated Returns',
//                     `₹${Math.round(
//                       result.estimatedReturns
//                     ).toLocaleString()}`,
//                   ],

//                   [
//                     'Future Value',
//                     `₹${Math.round(
//                       result.futureValue
//                     ).toLocaleString()}`,
//                   ],

//                   [
//                     'Inflation Adjusted Value',
//                     `₹${Math.round(
//                       result.inflationAdjustedValue
//                     ).toLocaleString()}`,
//                   ],

//                   [
//                     'Real Wealth Gain',
//                     `₹${Math.round(
//                       result.realReturns
//                     ).toLocaleString()}`,
//                   ],
//                 ].map(
//                   (row, index) => (
//                     <tr
//                       key={index}
//                       style={{
//                         borderBottom:
//                           '1px solid #ddd',
//                       }}
//                     >
//                       <td
//                         style={{
//                           padding:
//                             '12px',
//                           fontWeight:
//                             'bold',
//                         }}
//                       >
//                         {row[0]}
//                       </td>

//                       <td
//                         style={{
//                           padding:
//                             '12px',
//                         }}
//                       >
//                         {row[1]}
//                       </td>
//                     </tr>
//                   )
//                 )}
//               </tbody>
//             </table>

//             {/* DISCLAIMER */}
//             <div
//               style={{
//                 marginTop: '30px',
//                 background: '#f5f5f5',
//                 padding: '20px',
//                 borderRadius: '10px',
//               }}
//             >
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems:
//                     'center',
//                   gap: '10px',
//                   marginBottom:
//                     '10px',
//                 }}
//               >
//                 <FaShieldAlt />

//                 <strong>
//                   Mutual Fund
//                   Disclaimer
//                 </strong>
//               </div>

//               <p
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: '22px',
//                   color: '#555',
//                 }}
//               >
//                 Mutual Fund
//                 investments are
//                 subject to market
//                 risks. Please read
//                 all scheme related
//                 documents carefully
//                 before investing.
//                 Past performance is
//                 not indicative of
//                 future returns.
//               </p>
//             </div>

//             {/* FOOTER */}
//             <div
//               style={{
//                 marginTop: '25px',
//                 textAlign: 'center',
//                 fontSize: '12px',
//                 color: '#777',
//               }}
//             >
//               <p>
//                 This is a computer
//                 generated report by
//                 Wisdom Consultancy.
//               </p>

//               <p>
//                 www.wisdomconsultancy.in
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={
//             handleFormSubmit
//           }
//           onClose={() =>
//             setShowForm(false)
//           }
//           calculatorType="Lumpsum"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default LumpsumCalculator;

import React, { useState, useEffect, useRef } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';

import html2pdf from 'html2pdf.js';
import CalculatorForm from './CalculatorForm';
import { motion } from 'framer-motion';

import {
  FaChartLine,
  FaFilePdf,
  FaShieldAlt,
  FaArrowUp,
  FaMoneyBillWave,
} from 'react-icons/fa';

const LumpsumCalculator = () => {
  const [investment, setInvestment] =
    useState(100000);

  const [expectedReturn, setExpectedReturn] =
    useState(12);

  const [inflationRate, setInflationRate] =
    useState(6);

  const [timePeriod, setTimePeriod] =
    useState(10);

  const [showForm, setShowForm] =
    useState(false);

  const [result, setResult] = useState(null);

  const [chartData, setChartData] = useState([]);

  const resultRef = useRef(null);

  const formatCurrency = (value) => {
    return Math.round(value).toLocaleString('en-IN');
  };

  const calculate = () => {
    const rate = expectedReturn / 100;

    const inflation = inflationRate / 100;

    const futureValue =
      investment *
      Math.pow(1 + rate, timePeriod);

    const inflationAdjustedValue =
      futureValue /
      Math.pow(
        1 + inflation,
        timePeriod
      );

    const estimatedReturns =
      futureValue - investment;

    const realReturns =
      inflationAdjustedValue -
      investment;

    const inflationLoss = futureValue - inflationAdjustedValue;

    // CHART DATA
    const data = [];

    for (
      let year = 1;
      year <= timePeriod;
      year++
    ) {
      const value =
        investment *
        Math.pow(1 + rate, year);

      const adjusted =
        value /
        Math.pow(
          1 + inflation,
          year
        );

      data.push({
        year: `${year}Y`,
        investment: Math.round(investment),
        value: Math.round(value),
        adjusted: Math.round(adjusted),
      });
    }

    setResult({
      futureValue,
      inflationAdjustedValue,
      totalInvestment: investment,
      estimatedReturns,
      realReturns,
      inflationLoss,
    });

    setChartData(data);
  };

  // AUTO SCROLL MOBILE
  useEffect(() => {
    if (
      result &&
      window.innerWidth < 1024
    ) {
      setTimeout(() => {
        resultRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    }
  }, [result]);

  const downloadPDF = () => {
    setShowForm(true);
  };

  const handleFormSubmit = (userData) => {
    const element = document.getElementById(
      'lumpsum-result-content'
    );

    const opt = {
      margin: [0.4, 0.4, 0.4, 0.4],

      filename: `Lumpsum_Report_${userData.name}.pdf`,

      image: {
        type: 'jpeg',
        quality: 1,
      },

      html2canvas: {
        scale: 2,
      },

      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait',
      },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save();

    setShowForm(false);

    // WHATSAPP MESSAGE
    const whatsappMessage = `
Dear ${userData.name},

Thank you for using Wisdom Consultancy Lumpsum Calculator.

📊 Investment Summary

• Investment Amount: ₹${investment.toLocaleString()}
• Expected Return: ${expectedReturn}% p.a.
• Inflation Rate: ${inflationRate}% p.a.
• Investment Period: ${timePeriod} Years

💰 Total Investment:
₹${investment.toLocaleString()}

📈 Estimated Returns:
₹${Math.round(
      result.estimatedReturns
    ).toLocaleString()}

🏆 Future Value:
₹${Math.round(
      result.futureValue
    ).toLocaleString()}

📉 Inflation Adjusted Value:
₹${Math.round(
      result.inflationAdjustedValue
    ).toLocaleString()}

📉 Inflation Impact:
₹${Math.round(
      result.inflationLoss
    ).toLocaleString()}

💹 Real Wealth Gain:
₹${Math.round(
      result.realReturns
    ).toLocaleString()}

For personalized financial guidance contact:

📞 +91 9726344477
📧 wisdom2secure@gmail.com

Wisdom Consultancy
Your Trusted Partner for Wealth & Financial Security
`;

    window.open(
      `https://wa.me/91${userData.phone}?text=${encodeURIComponent(
        whatsappMessage
      )}`,
      '_blank'
    );
  };

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 20,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      className="w-full"
    >
      {/* HEADER */}
      <div className="mb-10">
        <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
          <div className="w-11 h-11 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
            <FaMoneyBillWave />
          </div>

          <span className="font-semibold text-[#0b1c39]">
            Smart Wealth Planning
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-[#0b1c39] mb-4">
          Lumpsum Calculator
        </h2>

        <p className="text-gray-600 text-lg leading-8 max-w-3xl">
          Calculate your one-time
          investment growth with
          inflation-adjusted future
          value projections.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-10">
        {/* LEFT SECTION */}
        <div className="space-y-6">
          {/* INVESTMENT */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Investment Amount
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
                ₹{formatCurrency(investment)}
              </div>
            </div>

            <input
              type="range"
              min="10000"
              max="10000000"
              step="10000"
              value={investment}
              onChange={(e) =>
                setInvestment(
                  Number(
                    e.target.value
                  )
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>₹10K</span>
              <span>₹1Cr</span>
            </div>
          </div>

          {/* RETURN */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Expected Return
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-orange-500">
                {expectedReturn}%
              </div>
            </div>

            <input
              type="range"
              min="1"
              max="30"
              step="0.5"
              value={expectedReturn}
              onChange={(e) =>
                setExpectedReturn(
                  Number(
                    e.target.value
                  )
                )
              }
              className="w-full accent-orange-500"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>1%</span>
              <span>30%</span>
            </div>
          </div>

          {/* INFLATION */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Inflation Rate
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-pink-500">
                {inflationRate}%
              </div>
            </div>

            <input
              type="range"
              min="0"
              max="10"
              step="0.5"
              value={inflationRate}
              onChange={(e) =>
                setInflationRate(
                  Number(
                    e.target.value
                  )
                )
              }
              className="w-full accent-pink-500"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>0%</span>
              <span>10%</span>
            </div>

            {/* INFLATION IMPACT */}
            {result?.inflationLoss > 0 && (
              <motion.div
                initial={{
                  opacity: 0,
                  y: 10,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                className="mt-5 bg-gradient-to-r from-pink-50 to-orange-50 border border-pink-200 rounded-2xl p-5 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">
                      Inflation Impact
                    </p>

                    <h3 className="text-2xl font-bold text-pink-500">
                      ₹{formatCurrency(result.inflationLoss)}
                    </h3>
                  </div>

                  <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-500 text-xl">
                    📉
                  </div>
                </div>

                <p className="text-xs text-gray-500 mt-3 leading-5">
                  This shows how inflation reduces
                  your actual purchasing power over
                  time.
                </p>
              </motion.div>
            )}
          </div>

          {/* TIME */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Time Period
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
                {timePeriod} Years
              </div>
            </div>

            <input
              type="range"
              min="1"
              max="40"
              value={timePeriod}
              onChange={(e) =>
                setTimePeriod(
                  Number(
                    e.target.value
                  )
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>1 Year</span>
              <span>40 Years</span>
            </div>
          </div>

          {/* BUTTON */}
          <button
            onClick={calculate}
            className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-xl"
          >
            Calculate Investment
          </button>
        </div>

        {/* RIGHT RESULT */}
        {result && (
          <motion.div
            ref={resultRef}
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] border border-[#dce7ff] rounded-[35px] p-7"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="w-14 h-14 rounded-2xl bg-[#2e56b8] text-white flex items-center justify-center">
                <FaChartLine size={24} />
              </div>

              <div>
                <h3 className="text-3xl font-bold text-[#0b1c39]">
                  Investment Summary
                </h3>

                <p className="text-gray-500">
                  Lumpsum Growth Projection
                </p>
              </div>
            </div>

            <div className="space-y-5">
              <div className="bg-white rounded-2xl p-5 flex justify-between">
                <span>Total Investment</span>
                <span className="font-bold">
                  ₹{formatCurrency(result.totalInvestment)}
                </span>
              </div>

              <div className="bg-white rounded-2xl p-5 flex justify-between">
                <span>Estimated Returns</span>
                <span className="font-bold text-[#69bf74]">
                  ₹{formatCurrency(result.estimatedReturns)}
                </span>
              </div>

              <div className="bg-white rounded-2xl p-5 flex justify-between">
                <span>Inflation Adjusted Value</span>
                <span className="font-bold text-orange-500">
                  ₹{formatCurrency(result.inflationAdjustedValue)}
                </span>
              </div>

              <div className="bg-white rounded-2xl p-5 flex justify-between">
                <span>Inflation Impact</span>
                <span className="font-bold text-pink-500">
                  - ₹{formatCurrency(result.inflationLoss)}
                </span>
              </div>

              <div className="bg-[#2e56b8] rounded-[30px] p-7 text-white shadow-xl">
                <p className="text-white/80 mb-3 text-lg">
                  Total Future Value
                </p>

                <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
                  ₹{formatCurrency(result.futureValue)}
                </h2>

                <div className="flex items-center gap-2 text-white/90">
                  <FaArrowUp />
                  <span>
                    Real Wealth Gain: ₹{formatCurrency(result.realReturns)}
                  </span>
                </div>
              </div>
            </div>

            {/* DOWNLOAD */}
            <button
              onClick={downloadPDF}
              className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
            >
              <FaFilePdf />
              Download Professional PDF Report
            </button>
          </motion.div>
        )}
      </div>

      {/* CHART */}
      {chartData.length > 0 && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          className="mt-16"
        >
          <h3 className="text-3xl font-bold text-[#0b1c39] mb-8">
            Investment Growth Projection
          </h3>

          <div className="bg-[#f8fbff] rounded-[35px] border border-[#edf3ff] p-6">
            <div className="h-[450px]">
              <ResponsiveContainer
                width="100%"
                height="100%"
              >
                <AreaChart
                  data={chartData}
                >
                  <defs>
                    <linearGradient
                      id="colorValue"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor="#69bf74"
                        stopOpacity={0.4}
                      />
                      <stop
                        offset="95%"
                        stopColor="#69bf74"
                        stopOpacity={0}
                      />
                    </linearGradient>
                  </defs>

                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="year" />

                  <YAxis />

                  <Tooltip
                    formatter={(value) =>
                      `₹${formatCurrency(value)}`
                    }
                  />

                  <Legend />

                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="#69bf74"
                    fillOpacity={1}
                    fill="url(#colorValue)"
                    strokeWidth={3}
                    name="Future Value"
                  />

                  <Line
                    type="monotone"
                    dataKey="investment"
                    stroke="#2e56b8"
                    strokeWidth={3}
                    name="Investment"
                  />

                  <Line
                    type="monotone"
                    dataKey="adjusted"
                    stroke="#ff9800"
                    strokeWidth={3}
                    name="Inflation Adjusted"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        </motion.div>
      )}

      {/* PDF CONTENT */}
      {result && (
        <div
          id="lumpsum-result-content"
          style={{
            display: 'none',
          }}
        >
          <div
            style={{
              padding: '30px',
              fontFamily: 'Arial',
              color: '#222',
            }}
          >
            {/* HEADER */}
            <div
              style={{
                borderBottom:
                  '3px solid #2e56b8',
                paddingBottom: '20px',
                marginBottom: '20px',
              }}
            >
              <h1
                style={{
                  color: '#2e56b8',
                  marginBottom: '10px',
                }}
              >
                Wisdom Consultancy
              </h1>

              <p>
                E-44, Vasant Vihar Society,
                GIDC-Vadsar Road,
                Vadodara-390010
              </p>

              <p>
                Phone: +91 9726344477 | Email:
                wisdom2secure@gmail.com
              </p>

              <p>
                ARN No: ARN-XXXXX
              </p>
            </div>

            {/* REPORT TITLE */}
            <h2
              style={{
                textAlign: 'center',
                color: '#0b1c39',
                marginBottom: '20px',
              }}
            >
              Lumpsum Investment Report
            </h2>

            {/* TABLE */}
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
              }}
            >
              <tbody>
                {[
                  ['Investment Amount', `₹${investment.toLocaleString()}`],
                  ['Expected Return', `${expectedReturn}%`],
                  ['Inflation Rate', `${inflationRate}%`],
                  ['Investment Period', `${timePeriod} Years`],
                  ['Total Investment', `₹${investment.toLocaleString()}`],
                  ['Estimated Returns', `₹${formatCurrency(result.estimatedReturns)}`],
                  ['Future Value', `₹${formatCurrency(result.futureValue)}`],
                  ['Inflation Adjusted Value', `₹${formatCurrency(result.inflationAdjustedValue)}`],
                  ['Inflation Impact', `- ₹${formatCurrency(result.inflationLoss)}`],
                  ['Real Wealth Gain', `₹${formatCurrency(result.realReturns)}`],
                ].map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: '1px solid #ddd',
                    }}
                  >
                    <td
                      style={{
                        padding: '12px',
                        fontWeight: 'bold',
                      }}
                    >
                      {row[0]}
                    </td>
                    <td
                      style={{
                        padding: '12px',
                      }}
                    >
                      {row[1]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* DISCLAIMER */}
            <div
              style={{
                marginTop: '30px',
                background: '#f5f5f5',
                padding: '20px',
                borderRadius: '10px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  marginBottom: '10px',
                }}
              >
                <FaShieldAlt />
                <strong>Mutual Fund Disclaimer</strong>
              </div>

              <p
                style={{
                  fontSize: '12px',
                  lineHeight: '22px',
                  color: '#555',
                }}
              >
                Mutual Fund investments are
                subject to market risks. Please read
                all scheme related documents carefully
                before investing. Past performance is
                not indicative of future returns.
              </p>
            </div>

            {/* FOOTER */}
            <div
              style={{
                marginTop: '25px',
                textAlign: 'center',
                fontSize: '12px',
                color: '#777',
              }}
            >
              <p>
                This is a computer generated report by Wisdom Consultancy.
              </p>
              <p>www.wisdomconsultancy.in</p>
            </div>
          </div>
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <CalculatorForm
          onSubmit={handleFormSubmit}
          onClose={() => setShowForm(false)}
          calculatorType="Lumpsum"
        />
      )}
    </motion.div>
  );
};

export default LumpsumCalculator;